<template>
  <svg
    width="16"
    height="11"
    viewBox="0 0 16 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1724_4387)">
      <path
        d="M12.3611 1.12512C12.49 1.25404 12.5624 1.42888 12.5624 1.61118C12.5624 1.79348 12.49 1.96832 12.3611 2.09724L8.95796 5.50037L12.3611 8.90349C12.4863 9.03316 12.5556 9.20682 12.5541 9.38708C12.5525 9.56734 12.4802 9.73978 12.3527 9.86724C12.2252 9.99471 12.0528 10.067 11.8726 10.0686C11.6923 10.0701 11.5186 10.0009 11.389 9.87562L7.49978 5.98643C7.37089 5.85751 7.29848 5.68267 7.29848 5.50037C7.29848 5.31807 7.37089 5.14323 7.49978 5.01431L11.389 1.12512C11.5179 0.996233 11.6927 0.923828 11.875 0.923828C12.0573 0.923828 12.2322 0.996233 12.3611 1.12512Z"
        fill="#545454"
      />
    </g>
    <g clip-path="url(#clip1_1724_4387)">
      <path
        d="M7.36109 1.12512C7.48997 1.25404 7.56238 1.42888 7.56238 1.61118C7.56238 1.79348 7.48997 1.96832 7.36109 2.09724L3.95796 5.50037L7.36109 8.90349C7.48632 9.03316 7.55562 9.20682 7.55405 9.38708C7.55249 9.56734 7.48018 9.73978 7.35271 9.86724C7.22525 9.99471 7.05281 10.067 6.87255 10.0686C6.69229 10.0701 6.51863 10.0009 6.38896 9.87562L2.49978 5.98643C2.37089 5.85751 2.29848 5.68267 2.29848 5.50037C2.29848 5.31807 2.37089 5.14323 2.49978 5.01431L6.38896 1.12512C6.51789 0.996233 6.69272 0.923828 6.87502 0.923828C7.05733 0.923828 7.23216 0.996233 7.36109 1.12512Z"
        fill="#545454"
      />
    </g>
    <defs>
      <clipPath id="clip0_1724_4387">
        <rect
          width="11"
          height="11"
          fill="white"
          transform="matrix(-1 8.74228e-08 8.74228e-08 1 16 0)"
        />
      </clipPath>
      <clipPath id="clip1_1724_4387">
        <rect
          width="11"
          height="11"
          fill="white"
          transform="matrix(-1 8.74228e-08 8.74228e-08 1 11 0)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
